<template>
  <div class="header-title">
    <div class="headerDiv clearfix">
      <div class="header"></div>
      <span class="title">{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title"],
};
</script>

<style lang="scss" scoped>
.header-title {
  width: 100%;
  padding: 0 35px;
  .headerDiv {
    padding: 0px 0px 20px 0px;
    
    .header {
      width: 3px;
      height: 16px;
      background: #d63630;
      border-radius: 6px;
      font-size: 16px;
      float: left;
      margin-top: 4px;
    }
    .title {
      float: left;
      font-size: 16px;
      font-weight: bold;
      padding-left: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login/headerTitle.vue